import { IconsProps } from '@/types/shared'
import React from 'react'

const AddCircleIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    x="0.160156"
                    y="0.965942"
                    width="17.3872"
                    height="17.3872"
                    rx="8.69362"
                    fill="#89C9B8"
                />
                <path
                    d="M8.37122 12.0745H9.33718V10.1425H11.2691V9.17658H9.33718V7.24467H8.37122V9.17658H6.43931V10.1425H8.37122V12.0745ZM8.8542 14.4893C8.18608 14.4893 7.55821 14.3626 6.97058 14.109C6.38296 13.8554 5.87181 13.5113 5.43713 13.0766C5.00245 12.642 4.65832 12.1308 4.40476 11.5432C4.1512 10.9556 4.02441 10.3277 4.02441 9.65956C4.02441 8.99144 4.1512 8.36357 4.40476 7.77594C4.65832 7.18832 5.00245 6.67717 5.43713 6.24249C5.87181 5.8078 6.38296 5.46368 6.97058 5.21012C7.55821 4.95655 8.18608 4.82977 8.8542 4.82977C9.52232 4.82977 10.1502 4.95655 10.7378 5.21012C11.3254 5.46368 11.8366 5.8078 12.2713 6.24249C12.706 6.67717 13.0501 7.18832 13.3036 7.77594C13.5572 8.36357 13.684 8.99144 13.684 9.65956C13.684 10.3277 13.5572 10.9556 13.3036 11.5432C13.0501 12.1308 12.706 12.642 12.2713 13.0766C11.8366 13.5113 11.3254 13.8554 10.7378 14.109C10.1502 14.3626 9.52232 14.4893 8.8542 14.4893ZM8.8542 13.5234C9.93285 13.5234 10.8465 13.1491 11.5951 12.4005C12.3437 11.6518 12.718 10.7382 12.718 9.65956C12.718 8.58091 12.3437 7.66727 11.5951 6.91866C10.8465 6.17004 9.93285 5.79573 8.8542 5.79573C7.77555 5.79573 6.86191 6.17004 6.1133 6.91866C5.36468 7.66727 4.99037 8.58091 4.99037 9.65956C4.99037 10.7382 5.36468 11.6518 6.1133 12.4005C6.86191 13.1491 7.77555 13.5234 8.8542 13.5234Z"
                    fill="white"
                />
            </svg>
        </div>
    )
}

export default AddCircleIcons
